import PropTypes from 'prop-types';
import React from 'react';
import Button from "../../Buttons/Button";

var BackButton = function BackButton(_a) {
  var text = _a.text;
  return history.length ? React.createElement(Button, {
    kind: "primary",
    onClick: function onClick() {
      return history.back();
    }
  }, text) : null;
}; // @ts-ignore


BackButton.propTypes = {
  text: PropTypes.string
};
BackButton.defaultProps = {
  text: 'Go Back'
};
export default BackButton;

try {
  // @ts-ignore
  BackButton.__docgenInfo = {
    "description": "",
    "displayName": "BackButton",
    "props": {
      "text": {
        "defaultValue": null,
        "description": "",
        "name": "text",
        "required": false,
        "type": {
          "name": "ReactNode"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}